import { render, staticRenderFns } from "./ListHeader2.vue?vue&type=template&id=751cf35d&scoped=true"
import script from "./ListHeader2.vue?vue&type=script&lang=js"
export * from "./ListHeader2.vue?vue&type=script&lang=js"
import style0 from "./ListHeader2.vue?vue&type=style&index=0&id=751cf35d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751cf35d",
  null
  
)

export default component.exports